import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Header } from "@/components/Header";
import { ServiceBoard } from "@/components/ServiceBoard";
import { Marquee } from "@/components/Marquee";
import { CategoryCards } from "@/components/CategoryCards";
import { EventsSection } from "@/components/EventsSection";
import { CleaningSection } from "@/components/CleaningSection";
import { GardenSection } from "@/components/GardenSection";
import { EventDetailDialog } from "@/components/EventDetailDialog";
import { Footer } from "@/components/Footer";
import BookingsPage from "@/pages/BookingsPage";
import BookingPage from "@/pages/BookingPage";
import BookingFormPage from "@/pages/BookingFormPage";

function HomePage() {
  const navigate = useNavigate();
  const [eventDetail, setEventDetail] = useState(null);
  const [openService, setOpenService] = useState(null);

  const startBooking = (payload) => {
    sessionStorage.setItem("am_cart", JSON.stringify(payload));
    navigate("/book");
  };

  const handleBoardTile = (section, service) => {
    if (section === "events") {
      setEventDetail(service);
      return;
    }
    setOpenService({ section, id: service.id, ts: Date.now() });
    setTimeout(() => {
      document
        .querySelector(`[data-testid="${section}-card-${service.id}"]`)
        ?.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 80);
  };

  return (
    <>
      <Header />
      <main>
        <ServiceBoard onTile={handleBoardTile} />
        <Marquee />
        <CategoryCards />
        <GardenSection
          onBook={startBooking}
          forceOpenId={openService?.section === "garden" ? openService.id : null}
          forceKey={openService?.ts}
        />
        <EventsSection onBook={startBooking} onOpenDetail={setEventDetail} />
        <CleaningSection
          onBook={startBooking}
          forceOpenId={openService?.section === "cleaning" ? openService.id : null}
          forceKey={openService?.ts}
        />
      </main>
      <Footer />
      <EventDetailDialog
        service={eventDetail}
        onClose={() => setEventDetail(null)}
        onBook={startBooking}
      />
    </>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ anchors: true, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="min-h-screen bg-[#FAF9F6] text-stone-900 font-body">
        <Toaster position="top-center" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/book" element={<BookingPage />} />
            <Route path="/booking-form" element={<BookingFormPage />} />
            <Route path="/bookings" element={<BookingsPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
